import { call, put, takeEvery } from 'redux-saga/effects';
import { getPriceOMConfig } from '../../requests/get_priceom_config_request';
import { getPriceOMConfigRequestSuccess, getPriceOMConfigRequestFailure } from '../actions/get_priceom_config.actions';
import { GET_PRICEOM_CONFIG_REQUEST } from '../constants/priceom_config.constants';

function* getPriceOMRequest() {
    const config = yield call(getPriceOMConfig); const
        { result, options } = config;
    return result
        ? yield put(getPriceOMConfigRequestSuccess(options))
        : yield put(getPriceOMConfigRequestFailure('Something gone wrong!'));
}

export default function* getPriceOMSaga() {
    yield takeEvery(GET_PRICEOM_CONFIG_REQUEST, getPriceOMRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/redux/sagas/get_priceom_config.saga.js